export function mountPwa() {
 if(!('serviceWorker' in navigator) || !window.isSecureContext)return;
 // Development stays live; offline checks use the packaged site.
 if(['localhost','127.0.0.1','[::1]'].includes(location.hostname))return;
 navigator.serviceWorker.register('/sw.js',{scope:'/',updateViaCache:'none'}).catch(console.error);
}
